$(document).ready(function() {
    // $('input[type="tel"]').mask('+7 999 999-9999', { autoclear: false }, { placeholder: '+7             ' });

    setTimeout(()=>{
        $(".header").addClass("_loaded")
    },10)

    $(".fg select").niceSelect()

    fix100vh();
    window.addEventListener('resize', () => {
        fix100vh();
    })
});

function fix100vh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}


$(document).on('click', '.filter-btn2', function(e) {
    $(".products-modal").addClass("_opened-filter")
})
